export const lecturerTableOption = {
    border: true,
    stripe: true,
    menuAlign: 'center',
    editBtn: false,
    delBtn: false,
    align: 'center',
    addBtn: false,
    refreshBtn: true,
    columnBtn: false,
    menu:false,
    page:false,
    column: [
    {
      label: '培训老师名称',
      prop: 'lecturer',
      span: 24,
    },
    {
      label: '培训老师员工编号',
      prop: 'unionId',
      span: 24,
    },
    {
      label: '培训课程数',
      prop: 'courseCount',
      span: 24,
      sortable: true,
    },
    {
      label: '问卷参与人数',
      prop: 'totalParticipantCount',
      span: 24,
    },
    {
      label: '总评分',
      prop: 'totalScore',
      span: 24,
    },
    {
      label: '平均评分',
      prop: 'averageScore',
      span: 24,
    }]
}

export const subLobTableOption = {
    border: true,
    stripe: true,
    menuAlign: 'center',
    editBtn: false,
    delBtn: false,
    align: 'center',
    addBtn: false,
    refreshBtn: true,
    columnBtn: false,
    menu:false,
    page:false,
    column: [
    {
      label: '培训团队',
      prop: 'organizedBy',
      span: 24,
    },
    {
      label: '培训课程数',
      prop: 'courseCount',
      span: 24,
      sortable: true,
    }]
}